import { StringAdapter } from "@/infrastructure/adapters/string";

const stringAdapter = new StringAdapter();

export const PO_NUMBER_SEARCH_CONSTANTS = {
  MAX_LENGTH: 100,
  MIN_LENGTH: 2,
} as const;

/**
 * Validates PO number search input
 * Returns true if invalid, false if valid
 */
export const validatePONumberSearch = (value: string | null | undefined): boolean => {
  if (!value) return false;

  const searchValue = stringAdapter.trim(value);
  if (searchValue.length === 0) {
    return false;
  }
  if (searchValue.length < PO_NUMBER_SEARCH_CONSTANTS.MIN_LENGTH) {
    return true;
  }

  const searchValueArray = stringAdapter.split(searchValue);
  for (const item of searchValueArray) {
    if (stringAdapter.trim(item).length < PO_NUMBER_SEARCH_CONSTANTS.MIN_LENGTH) {
      return true;
    }
  }
  return false;
};

